module.exports = __webpack_public_path__ + "static/media/3.08bb3e49.jpg";